/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {Component, OnInit} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {FabMessageService} from '@fabric/components/message';
import {
  ColDef,
  SizeColumnsToContentStrategy,
  SizeColumnsToFitGridStrategy,
  SizeColumnsToFitProvidedWidthStrategy
} from 'ag-grid-community';
import {DISMISS_MSG} from '../../../common/constants';
import {CustomButtonCellComponent} from '../../../core/components/custom-button-cell/custom-button-cell.component';
import {ProgramCodeDTO} from '../../../models/program-code-dto.model';
import {ArchDevianceService} from '../../../services/arch-deviance.service';
import {EditArchDeviancePopUpComponent} from './edit-arch-deviance-pop-up/edit-arch-deviance-pop-up.component';

@Component({
    selector: 'app-manage-arch-deviances',
    templateUrl: './manage-arch-deviances.component.html',
    styleUrls: ['./manage-arch-deviances.component.scss'],
    standalone: false
})
export class ManageArchDeviancesComponent implements OnInit {
  showSpinner: boolean;
  prgmCodeList: ProgramCodeDTO[] = [];

  columnDefs: ColDef[] = [
    {field: 'prgmCode', headerName: 'Program Code'},
    {
      headerName: 'Edit',
      field: 'actions',
      cellRenderer: CustomButtonCellComponent,
      cellRendererParams: {
        icon: 'edit',
        onClick: this.openArchDialog.bind(this)
      }
    }
  ];
  autoSizeStrategy:
    | SizeColumnsToFitGridStrategy
    | SizeColumnsToFitProvidedWidthStrategy
    | SizeColumnsToContentStrategy = {
    type: "fitGridWidth",
  };

  constructor(public snackBar: FabMessageService,
              public dialog: MatDialog,
              public archDevianceService: ArchDevianceService) {
  }


  ngOnInit(): void {
    this.checksForDeviances();
  }

  /**
   * Sends a request to check which program codes have any deviance's.
   * Returns a list of Program codes.
   */
  checksForDeviances(): void {
    this.prgmCodeList = [];
    this.showSpinner = true;
    this.archDevianceService.getNonCompliantProgramCodes().subscribe({
      next: (data) => {
        data.forEach((value) => {
          this.prgmCodeList.push({prgmCode: value});
        });
      },
      error: err => {
        this.snackBar.displayError(err, DISMISS_MSG);
        this.showSpinner = false;
      },
      complete: () => {
        this.showSpinner = false;
      }
    });
  }

  /**
   * Opens a dialog to set an arch value for the selected program code
   * @param prgmCode program code
   */
  openArchDialog(prgmCode: ProgramCodeDTO): void {
    const dialogRef = this.dialog.open(EditArchDeviancePopUpComponent, {
      data: prgmCode
    });
    dialogRef.afterClosed().subscribe({
      next: (res) => {
        if (res && res.updatePrgmCodeList) {
          this.checksForDeviances();
        }
      },
    });
  }
}
